import { ACTION_COMMANDS_EVENT_TYPE, ACTION_COMMANDS_TYPE } from '../../../api/ActionCommandsInterface/constants';
import { EVENT_EMITTER_TYPE, FTUE_EVENT_TYPES } from '../../../constants';
import { sendFtueEvent } from '../../../lib/analytics/ftueLogger';
import Emitter from '../../../services/EmitterService';
export var skipTutorialGame = function skipTutorialGame(ftueStep, clearOnboarding, actionCommands) {
  var _actionCommands$gameT, _actionCommands$gameT2, _actionCommands$gameT3, _actionCommands$gameT4;

  sendFtueEvent(FTUE_EVENT_TYPES.FTUE_TUTORIAL_SKIP, {
    step: ftueStep
  });
  clearOnboarding();
  Emitter.emit(EVENT_EMITTER_TYPE.ACTION_COMMANDS, {
    actionType: ACTION_COMMANDS_TYPE.NOTIFY_TRIGGER_PROCESSED_REQUEST,
    data: {
      event: ACTION_COMMANDS_EVENT_TYPE.SKIP_ONBOARDING_TUTORIAL,
      triggerExecution: actionCommands === null || actionCommands === void 0 ? void 0 : (_actionCommands$gameT = actionCommands.gameTutorial) === null || _actionCommands$gameT === void 0 ? void 0 : (_actionCommands$gameT2 = _actionCommands$gameT.onSkipAction) === null || _actionCommands$gameT2 === void 0 ? void 0 : _actionCommands$gameT2.triggerExecution,
      payload: actionCommands === null || actionCommands === void 0 ? void 0 : (_actionCommands$gameT3 = actionCommands.gameTutorial) === null || _actionCommands$gameT3 === void 0 ? void 0 : (_actionCommands$gameT4 = _actionCommands$gameT3.onSkipAction) === null || _actionCommands$gameT4 === void 0 ? void 0 : _actionCommands$gameT4.payload
    }
  });
  Emitter.emit(EVENT_EMITTER_TYPE.ACTION_COMMANDS, {
    actionType: ACTION_COMMANDS_TYPE.CLEAR_ACTION_COMMAND
  });
};